// 端外fetch
import axios from 'axios';
// import SparkMD5 from 'spark-md5';
import md5 from 'md5';
import { isIos } from './tools';

const service = axios.create({
  baseURL: 'https://feed-api.capcutapi.com',
  timeout: 30000,
  headers: {},
});

service.interceptors.request.use(config => {
  const { url = '' } = config;
  const pf = isIos ? 1 : 0;
  const appvr = '';
  const deviceTime = parseInt((Date.now() / 1000).toString(), 10);
  const tdid = '';
  const rawStr = `9e2c|${url.slice(-7)}|${pf}|${appvr}|${deviceTime}|${tdid}|11ac`;
  const sign = md5(rawStr);
  return {
    ...config,
    headers: {
      ...config.headers,
      appvr,
      'device-time': deviceTime,
      loc: 'BR',
      pf,
      sign,
      'content-type': 'application/json',
      'sign-ver': '1',
      'app-sdk-version': '100.0.0',
    },
  };
});

service.interceptors.response.use(response => response.data);

export default service;
